// extracted by mini-css-extract-plugin
module.exports = {"modal":"rule_modal__EpDgd","modalTitle":"rule_modalTitle__3l9VE","modalContent":"rule_modalContent__3aMlf","modalFooter":"rule_modalFooter__3U8bh","button":"rule_button__2rLBU"};